// Copyright (c) 2021 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/type/workday.proto (package legebill.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DayOfWeek } from "../../google/type/dayofweek_pb";
import { file_google_type_dayofweek } from "../../google/type/dayofweek_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legebill/type/workday.proto.
 */
export const file_legebill_type_workday: GenFile = /*@__PURE__*/
  fileDesc("ChtsZWdlYmlsbC90eXBlL3dvcmtkYXkucHJvdG8SDWxlZ2ViaWxsLnR5cGUiTgoHV29ya2RheRIrCgtkYXlfb2Zfd2VlaxgBIAEoDjIWLmdvb2dsZS50eXBlLkRheU9mV2VlaxIWCg53b3JrX2hvdXJzX3B0cxgCIAEoDUInChVjb20ubGVnZWJpbGwuYXBpLnR5cGVCDFdvcmtkYXlQcm90b1ABYgZwcm90bzM", [file_google_type_dayofweek]);

/**
 * Defines the expected work hours for a day of the week.
 *
 * A post expectation is configured with default work days.
 * Optionally, a membership may override them.
 *
 * @generated from message legebill.type.Workday
 */
export type Workday = Message<"legebill.type.Workday"> & {
  /**
   * @generated from field: google.type.DayOfWeek day_of_week = 1;
   */
  dayOfWeek: DayOfWeek;

  /**
   * Expressed as percentage points, default 650 (6.5)
   * Value must be <= 2400
   *
   * @generated from field: uint32 work_hours_pts = 2;
   */
  workHoursPts: number;
};

/**
 * Describes the message legebill.type.Workday.
 * Use `create(WorkdaySchema)` to create a new message.
 */
export const WorkdaySchema: GenMessage<Workday> = /*@__PURE__*/
  messageDesc(file_legebill_type_workday, 0);

